import { render, staticRenderFns } from "./Activity.vue?vue&type=template&id=23452740&scoped=true"
import script from "./Activity.vue?vue&type=script&lang=js"
export * from "./Activity.vue?vue&type=script&lang=js"
import style0 from "./Activity.vue?vue&type=style&index=0&id=23452740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23452740",
  null
  
)

export default component.exports